
import { InjectionToken } from '@angular/core'

export const CROSS_PLATFORM_TOKEN = new InjectionToken('Cross platform token')
